var map = {
	"./camera.png": 827,
	"./camera/axis.gif": 2292,
	"./camera/hikvision.gif": 2222,
	"./camera/milesight.gif": 2293,
	"./conditions/in_area.png": 3718,
	"./conditions/intersects.png": 3719,
	"./conditions/time.png": 3720,
	"./conditions/time_of_day.png": 3721,
	"./grafana.png": 2223,
	"./kit.gif": 2294,
	"./main.jpg": 1349,
	"./nvr.png": 828,
	"./objects/articulated-dumper.png": 3722,
	"./objects/backhoe-loader.png": 3723,
	"./objects/compact-excavator.png": 3724,
	"./objects/concrete-pump.png": 3725,
	"./objects/dumper.png": 3726,
	"./objects/excavator.png": 3727,
	"./objects/flatbed-semi-trailer.png": 3728,
	"./objects/industrial-truck.png": 3729,
	"./objects/loader.png": 3730,
	"./objects/mewps.png": 3731,
	"./objects/mobile-crane.png": 3732,
	"./objects/mobile-crusher.png": 3733,
	"./objects/pile-drilling-rig.png": 3734,
	"./objects/road-vehicle.png": 3735,
	"./objects/roller.png": 3736,
	"./objects/semi-trailer.png": 3737,
	"./objects/skid-steer-loader.png": 3738,
	"./objects/skip-truck.png": 3739,
	"./objects/small-truck.png": 3740,
	"./objects/tank-truck.png": 3741,
	"./objects/tele-handler.png": 3742,
	"./objects/tipping-truck.png": 3743,
	"./objects/tower-crane.png": 3744,
	"./objects/tractor-dozer.png": 3745,
	"./objects/truck-head.png": 3746,
	"./objects/truck-mixer.png": 3747,
	"./objects/worker.png": 3748,
	"./router.png": 829,
	"./router/rut955.gif": 2295,
	"./router/rut956.gif": 2296,
	"./router/rutx11.gif": 2297,
	"./router/rutx14.gif": 2298,
	"./sbc/rpi4.gif": 2299,
	"./solar.jpg": 1350,
	"./waiting_for_activation.jpg": 664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3717;